var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconX = function SvgIconX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.457 5.957a1 1 0 0 0-1.414-1.414L12 10.586 5.957 4.543a1 1 0 0 0-1.414 1.414L10.586 12l-6.043 6.043a1 1 0 1 0 1.414 1.414L12 13.414l6.043 6.043a1 1 0 0 0 1.414-1.414L13.414 12z"
  })));
};
export default SvgIconX;